export default {
  methods: {
    applyServerErrors(errors) {
      for (var field in errors) {
        for (var i = 0; i < errors[field].length; i++) {
          this.$validator.errors.add(field, errors[field][i], 'server');
        }
      }
    },
    submit(url, formData, callback) {
      var self = this;

      $('#loader-wrapper').show();
      $.ajax({
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST',
        success: function(data) {
          if(data.errors){

          $('#loader-wrapper').hide();
          }
          if(callback){
            callback(data);
          }else{
            self.errors.clear();
            if (data.redirect) {
              location.href = data.redirect;
            } else if (data.errors) {
              self.applyServerErrors(data.errors);
            } else {
              location.reload();
            }
          }
        },
        error: function(error) {
          console.log('error');
        }
      })
    }
  }
}
